import React, { useEffect, useState } from "react";
import Button from "../../../../components/common/ui/Button";
import {
  SelectInput,
  TextInput,
} from "../../../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { categoryActions } from "../../../../_store/category.slice";
import { masterActions } from "../../../../_store/master.slice";
import { useLocation } from "react-router-dom";
import { history } from "../../../../_helpers";
import categorySchema from "../../../../validation/Admin/CategorySchema";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "../../../../components/common/ui/Loader";

const AddorEditCategory = () => {
  const { categoryForm, categoryByIdList, loading } = useSelector(
    (x) => x.category
  );

  const { getCommitteeListResponse } = useSelector((x) => x?.master);

  // console.log("getCommitteeListResponse", getCommitteeListResponse);

  const location = useLocation();

  // const committeeID = location?.state ? location?.state?.committeeID : 0;
  const categoryId = location?.state ? location?.state?.categoryId : 0;
  const [errorMessage, setErrorMessage] = useState({});
  const [isPending, setIsPending] = useState(false);

  // get Committiee DropdownList
  useEffect(() => {
    dispatch(masterActions?.getCommitteeList());
  }, []);

  //get category by id
  useEffect(() => {
    if (categoryId === 0) {
      dispatch(categoryActions.resetCategoryForm());
      return;
    }
    dispatch(categoryActions.getCategoryByID(categoryId))
      .then((result) => {
        const res = {
          title: result?.payload?.data?.title || "",
          committee: result?.payload?.data?.createdBy || "",
        };
        dispatch(categoryActions?.updateCategoryForm(res));
      })
      .catch((err) => {
        showToastNotification("Failed to get Member data...");
      });
  }, [categoryId]);

  const dispatch = useDispatch();

  const handleChange = (e, select) => {
    let form = { ...categoryForm };

    if (select) {
      form[select] = e?.value;
      dispatch(categoryActions.updateCategoryForm(form));
      return;
    }
    let { name, value } = e.target;
    if (value.startsWith(" ")) return;

    form[name] = value;

    dispatch(categoryActions.updateCategoryForm(form));
  };

  const handleFormSubmit = (e) => {
    setIsPending(true);

    e?.preventDefault();

    setErrorMessage({});

    const { error } = categorySchema(categoryForm);

    if (error?.details) {
      setIsPending(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    //API call after validation
    const resquest = categoryId
      ? dispatch(
          categoryActions.updateCategory({
            id: categoryId,
            data: { title: categoryForm.title },
          })
        )
      : dispatch(categoryActions.CreateCategory(categoryForm));
    resquest
      .then((result) => {
        setIsPending(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          dispatch(categoryActions.resetCategoryForm());
          history?.navigate("/Admin/DocCategory", {
            state: { categoryId: 0 },
          });
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create committee", "error");
        setIsPending(false);
      });
  };

  const handleFormReset = () => {
    if (categoryId) {
      dispatch(categoryActions.getCategoryByID(categoryId))
        .then((result) => {
          const res = {
            title: result?.payload?.data?.title || "",
            committee: result?.payload?.data?.createdBy || "",
          };
          dispatch(categoryActions?.updateCategoryForm(res));
        })
        .catch((err) => {
          showToastNotification("Failed to get Member data...");
        });
    }
    setErrorMessage({});
    dispatch(categoryActions.resetCategoryForm());
  };
  if (loading) return <CustomLoader />;
  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">Documents Category</h1>
        <Button
          label="Back"
          status="reset"
          onClick={() => {
            history?.navigate("/Admin/DocCategory", {
              tate: { categoryId: 0 },
            });
            dispatch(categoryActions.resetCategoryForm());
          }}
        />
      </div>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
          {categoryId ? "Edit" : "Create"} Category
        </h1>
        <form
          onSubmit={(e) => {
            handleFormSubmit(e);
          }}
          onReset={(e) => {
            handleFormReset(e);
          }}
          className="p-3 row"
        >
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                label="Title"
                placeholder="Title"
                name="title"
                id="title"
                handleChange={(e) => handleChange(e)}
                required
                errorMessage={errorMessage}
                value={categoryForm?.title}
              />
            </div>
            {!categoryId && (
              <div className="col-md-4">
                <SelectInput
                  options={getCommitteeListResponse?.data}
                  name="committee"
                  id="committee"
                  label="Committee"
                  required
                  handleChange={(e) => handleChange(e, "committee")}
                  errorMessage={errorMessage}
                  value={categoryForm?.committee}
                />
              </div>
            )}
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <Button
              label={`${categoryId === 0 ? "Submit" : "Update"}`}
              type="submit"
              status="secondary"
              disabled={isPending}
            />
            <Button label="Reset" type="reset" status="reset" />
          </div>
        </form>
      </div>
    </>
  );
};

export default AddorEditCategory;
